import { ALLOWED_SPECIAL_SEGMENTS_NONE, BaseNamePathSegmentImpure, BaseNamePathSegmentToStemAndExtTuple, IsRootPathSegment } from './segment';
export function IsAbsolutePathSegments(path, options) {
    return IsRootPathSegment(path[0], options.rootRegExp);
}
export function IsRootPathSegments(path, options) {
    return (path.length === 1)
        && IsRootPathSegment(path[0], options.rootRegExp);
}
export function IsPureParentDirectoryPathSegments(path) {
    return path.every(segment => (segment === '..'));
}
export function AreSamePathSegments(path1, path2) {
    const length = path1.length;
    if (path2.length === length) {
        for (let i = 0; i < length; i++) {
            if (path1[i] !== path2[i]) {
                return false;
            }
        }
        return true;
    }
    else {
        return false;
    }
}
export function IsSubPathSegments(path, parentPath, equals = false) {
    if (parentPath.length >= (path.length + (equals ? 1 : 0))) {
        return false;
    }
    else {
        for (let i = 0, l = parentPath.length; i < l; i++) {
            if (path[i] !== parentPath[i]) {
                return false;
            }
        }
        return true;
    }
}
export function DirNamePathSegments(path) {
    if (IsPureParentDirectoryPathSegments(path)) {
        return [...path, '..'];
    }
    else if (path.length === 1) {
        return (path[0] === '.')
            ? ['..']
            : null;
    }
    else {
        return path.slice(0, -1);
    }
}
export function BaseNamePathSegments(path, ext, options) {
    return BaseNamePathSegmentImpure(path[path.length - 1], ext, options.rootRegExp, options.allowedSpecialSegments);
}
export function StemAndExtTuplePathSegments(path, options) {
    return BaseNamePathSegmentToStemAndExtTuple(BaseNamePathSegments(path, void 0, { ...options, allowedSpecialSegments: ALLOWED_SPECIAL_SEGMENTS_NONE }));
}
//# sourceMappingURL=infos.js.map